import * as React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
// import { BrowserRouter as Router, Routes } from 'react-router-dom';


ReactDOM.render(
  <App/>,
  document.getElementById('root')
);




ReactDOM.render(<App />, document.getElementById('root'));